import './styles.scss'
import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import PowerUserInfo from '../../../components/PowerUserInfo'

export default class Index extends Component {
  render() {
    return (
      <Container fluid className='user-settings-page py-5'>
        <Row>
          <Col lg={6}>
            <PowerUserInfo />
          </Col>
        </Row>
      </Container>
    )
  }
}
